"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _buttonClose = require("../button-close/button-close");
var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
    ariaCloseButtonLabel = _ref.ariaCloseButtonLabel,
    withCloseButton = _ref.withCloseButton,
    onCloseClick = _ref.onCloseClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal__header-content"
  }, children), withCloseButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal__close"
  }, /*#__PURE__*/_react["default"].createElement(_buttonClose.ButtonClose, {
    onClick: onCloseClick,
    ariaLabel: ariaCloseButtonLabel
  })));
};
ModalHeader.defaultProps = {
  ariaCloseButtonLabel: undefined,
  withCloseButton: true,
  onCloseClick: undefined,
  children: undefined
};
var _default = exports["default"] = ModalHeader;